import ExpandIcon from '@assets/icons/chevron-down.svg?react'
import CollapseIcon from '@assets/icons/chevron-up.svg?react'
import PaymentMethodSelect from '@components/PaymentMethodSelect'
import type { ExtendedSubFlow } from '@withdrawals/types'
import cn from 'classnames'
import { isValidArray, tr, useMatchMedia } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import styles from './SendMoneyNavigation.module.scss'

type SendMoneyNavigationProps = {
  loading: boolean
  selectedOption: any
  setSelectedOption: (option: ExtendedSubFlow, part: string) => void
  paymentOptions?: any[]
}

const SendMoneyNavigation = (props: SendMoneyNavigationProps) => {
  const { loading, paymentOptions, selectedOption, setSelectedOption } = props

  const [collapsed, setCollapsed] = useState<boolean>(false)

  const collapseEnabled = useMatchMedia({ breakpoint: 1280, prefix: 'max' })

  const toggleCollapsed = () => {
    setCollapsed(prevState => !prevState)
  }

  useEffect(() => {
    if (collapseEnabled) {
      setCollapsed(!selectedOption)
    }
  }, [selectedOption, collapseEnabled])

  return (
    <div className={styles.navigation}>
      <div className={cn(styles['navigation-header'], { collapsed })}>
        <div className={styles['navigation-title']}>
          {paymentOptions?.length === 1
            ? tr('FRONTEND.SEND_MONEY.PAYMENT_METHOD', 'Payment method')
            : tr('FRONTEND.SEND_MONEY.PAYMENT_METHOD_SELECT', 'Select payment method')}
        </div>
        {collapseEnabled && (
          <div className={styles['navigation-button']} onClick={toggleCollapsed}>
            {collapsed ? <CollapseIcon /> : <ExpandIcon />}
          </div>
        )}
      </div>
      <div className={styles['navigation-content']}>
        {isValidArray(paymentOptions) && (
          <PaymentMethodSelect
            className='payment-option'
            paymentOptions={paymentOptions}
            selectedPaymentOption={selectedOption}
            setSelectedPaymentOption={setSelectedOption}
            loading={loading}
            disabled={loading}
            collapse={collapsed}
            setCollapse={setCollapsed}
            ignoreStatus={true}
          />
        )}
      </div>
    </div>
  )
}

export default SendMoneyNavigation
